import { features } from '../config/platform';

/**
 * Media fetch for canvas/PDF/download paths.
 * - Cloud: signed play cookies / signed URLs (`credentials: 'include'`).
 * - On-prem: no Authorization header — images are loaded from the URL as-is.
 */
export const fetchProtectedMedia = async (url: string, init: RequestInit = {}): Promise<Response> => {
  const existingHeaders: Record<string, string> = {};

  if (init.headers instanceof Headers) {
    init.headers.forEach((value, key) => {
      existingHeaders[key] = value;
    });
  } else if (Array.isArray(init.headers)) {
    init.headers.forEach(([key, value]) => {
      existingHeaders[key] = value;
    });
  } else if (init.headers) {
    Object.assign(existingHeaders, init.headers);
  }

  return fetch(url, {
    method: 'GET',
    mode: 'cors',
    ...init,
    credentials: features.isOnpremisePortal ? 'omit' : 'include',
    headers: {
      ...existingHeaders,
    },
  });
};

export const fetchProtectedMediaBlob = async (url: string): Promise<Blob> => {
  const response = await fetchProtectedMedia(url);

  if (!response.ok) {
    throw new Error(`Failed to fetch media: ${response.status}`);
  }

  return response.blob();
};

export const fetchProtectedMediaObjectUrl = async (url: string): Promise<string> => {
  const blob = await fetchProtectedMediaBlob(url);
  return URL.createObjectURL(blob);
};
